import { render, staticRenderFns } from "./update.vue?vue&type=template&id=48493716&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports